import { useMemo, useState } from "react";

type UseBulkActionsFloatingBarHeightReturn = {
  height: number | undefined;
  setHeight: (height: number) => void;
};

const useBulkActionsFloatingBarHeight = (
  isBulkActionsActive: boolean
): UseBulkActionsFloatingBarHeightReturn => {
  const [height, setHeightState] = useState(0);

  const result = useMemo(() => {
    return {
      height: isBulkActionsActive ? height : undefined,
      setHeight: setHeightState,
    };
  }, [height, isBulkActionsActive, setHeightState]);

  return result;
};

export default useBulkActionsFloatingBarHeight;
